import React, { useContext } from "react";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useAuth } from "@/providers/AuthenticationProvider";
import { AppContext } from "@/providers/AppContext";
import type { ItemCatSubEnv } from "@/utilities/itemcat/itemCatSubEnv";

/**
 * STG/INT are two separate ITEMCAT hosts that both sit behind pubp's single
 * "stg" deployment — this lets a stg pubp user choose which one ITEMCAT
 * requests go to. Selection is persisted in AppContext/localStorage
 * (see itemCatSubEnv.ts) so getItemCatOrigin() can read it outside React.
 * Sits on the Items page's light-background action row, so this uses MUI's
 * default (dark-on-light) Select styling rather than the header's white-on-dark.
 */
export function ItemCatEnvSwitcher() {
  const { apiEnv } = useAuth();
  const { itemCatSubEnv, setItemCatSubEnv } = useContext(AppContext);

  if (apiEnv !== "stg") return null;

  const handleChange = (event: SelectChangeEvent) => {
    setItemCatSubEnv(event.target.value as ItemCatSubEnv);
  };

  return (
    <Select
      value={itemCatSubEnv}
      onChange={handleChange}
      size="small"
      variant="standard"
      data-testid="itemcat-env-switcher"
      inputProps={{ "aria-label": "ITEMCAT environment" }}
      sx={{
        "&::before, &::after": {
          borderBottom: "none"
        },
        "&:hover:not(.Mui-disabled, .Mui-error)::before": {
          borderBottom: "none"
        },
        ".MuiSelect-select": {
          paddingRight: "28px !important"
        }
      }}
    >
      <MenuItem value="STG" sx={{ fontWeight: itemCatSubEnv === "STG" ? 700 : 400 }}>
        STG
      </MenuItem>
      <MenuItem value="INT" sx={{ fontWeight: itemCatSubEnv === "INT" ? 700 : 400 }}>
        INT
      </MenuItem>
    </Select>
  );
}
